import { LuCkEditorToolBar } from '../../lu-ckeditor.models';

export const sessionDescriptionToolbar: LuCkEditorToolBar[] = [
	{
		name: 'clipboard',
		items: ['Paste', 'PasteText', 'PasteFromWord', '-', 'Undo', 'Redo']
	},
	{
		name: 'styles',
		items: ['Format', 'Font', 'FontSize']
	},
	{
		name: 'colors',
		items: ['TextColor', 'BGColor']
	},
	{
		name: 'paragraph',
		// tslint:disable-next-line
		items: [
			'NumberedList',
			'BulletedList',
			'-',
			'Outdent',
			'Indent',
			'-',
			'Blockquote',
			'-',
			'JustifyLeft',
			'JustifyCenter',
			'JustifyRight',
			'JustifyBlock',
			'HorizontalRule'
		]
	},
	{
		name: 'basicstyles',
		items: ['Bold', 'Italic', 'Underline', 'Subscript', 'Superscript', '-', 'Link', 'Unlink']
	},
	{
		name: 'advanced',
		items: ['Preview', 'Maximize']
	}
];
